<template>
  <v-app class="login-bg">
    <div class="login-pagina" :class="{ 'login-pagina--teclado': tecladoAbierto }">
      <div class="login-contenedor" :class="{ 'login-contenedor--solo': !hayPanel }">
        <!-- Anuncios y estado del servicio: vienen de source_config (GET api/anuncios). Sin ninguno no se
             muestra el panel y el formulario queda solo y centrado. Sólo en pantallas anchas: en el
             celular el formulario va solo. -->
        <aside v-if="hayPanel" class="login-novedades d-none d-md-flex">
          <img class="login-novedades__logo" src="/assets/images/brand/white-horizontal-logo.svg" alt="Nubempresa">
          <h2 class="login-novedades__bienvenida">Bienvenido de nuevo</h2>
          <div v-if="estadoServicio" class="login-estado" :class="'login-estado--' + estadoServicio.state" role="status">
            <v-icon class="login-estado__icono">{{ iconoEstado[estadoServicio.state] || iconoEstado.normal }}</v-icon>
            <span>{{ estadoServicio.message }}</span>
          </div>
          <h3 v-if="novedades.length" class="login-novedades__titulo">Novedades</h3>
          <div v-for="(n, i) in novedades" :key="i" class="login-novedad" :class="'login-novedad--' + n.type">
            <v-icon color="white" class="login-novedad__icono">{{ n.icon }}</v-icon>
            <div>
              <span class="login-novedad__tipo">{{ nombreTipo[n.type] || n.type }}</span>
              <strong class="d-block">{{ n.title }}</strong>
              <p class="mb-0">{{ n.body }}</p>
            </div>
          </div>
        </aside>

      <div class="login-caja">
        <img class="login-logo d-md-none" src="/assets/images/brand/white-horizontal-logo.svg" alt="Nubempresa">

        <div class="auth-glass login-tarjeta">
          <div class="d-flex align-center justify-space-between mb-4">
            <v-btn color="success" class="rounded-pill" small :title="$t('support')"
              href="https://wa.me/+573195675844" elevation="0" outlined>
              <v-icon small left>mdi-whatsapp</v-icon>
              <span>{{ $t("support") }}</span>
            </v-btn>
            <v-switch v-model="keyboardMode" inset dense hide-details class="login-teclado mt-0 pt-0"
              prepend-icon="mdi-keyboard" label="Teclado" title="Teclado en pantalla"></v-switch>
          </div>

          <div class="text-center mb-5">
            <div class="login-encabezado">
              <div class="login-insignia"><v-icon color="white" size="26">mdi-point-of-sale</v-icon></div>
              <h1 class="login-titulo success--text">Nubempresa POS</h1>
            </div>
            <p class="grey--text text--darken-2 mb-0">
              Inicia sesión con tu correo y tu contraseña.
            </p>
          </div>

          <v-alert v-if="responseError" type="error" dense text class="mb-4">
            {{ mensajeError || $t("Credenciales inválidas") }}
          </v-alert>

          <ValidationObserver v-slot="{ invalid }" ref="form">
            <form class="v-form" @submit.prevent="loginWithPasswd()">
              <div @focusin="campoActivo = 'email'" @click="campoActivo = 'email'">
                <ng-text prepend-inner-icon="mdi-email-outline" autocomplete="new-password" v-model="form.email" :filled="false"
                  :dense="false" :label="'Correo'" rules="required|email|min:8"
                  show-required="true" :inputmode="keyboardMode ? 'none' : undefined" />
              </div>
              <div @focusin="campoActivo = 'password'" @click="campoActivo = 'password'">
                <ng-passwd prepend-inner-icon="mdi-lock-outline" v-model="form.password" :filled="false" :dense="false"
                  :label="$t('password')" rules="required|min:8"
                  show-required="true" v-on:keyup.enter="loginWithPasswd" autocomplete="new-password"
                  :inputmode="keyboardMode ? 'none' : undefined" />
              </div>

              <div class="text-right mb-5">
                <router-link to="/auth/recover" class="link success--text">
                  {{ $t("forgot_password") }}
                </router-link>
              </div>

              <v-btn elevation="0" block large color="success" :disabled="invalid || loading" :loading="loading"
                @click="loginWithPasswd()">
                {{ $t("log_in") }}
              </v-btn>
            </form>
          </ValidationObserver>
        </div>
      </div>
      </div>
    </div>
    <tecladoLogin :abierto="tecladoAbierto" :valor="valorCampo" :etiqueta="campoActivo === 'password' ? $t('password') : 'Correo'"
      :accion="campoActivo === 'password' ? 'Ingresar' : 'Siguiente'" @cambio="escribirDesdeTeclado"
      @accion="accionTeclado" @cerrar="tecladoOculto = true" />
  </v-app>
</template>

<style lang="scss" src="@/components/base/estilos-login.scss"></style>

<style lang="scss">
.login-contenedor {
  position: relative;
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 64px;
}

.login-caja {
  width: 100%;
  max-width: 440px;
  margin: 0 auto;
}

.login-novedades {
  flex: 1;
  flex-direction: column;
  color: #fff;
}

.login-novedades__logo {
  width: 220px;
  margin-bottom: 32px;
}

.login-novedades__bienvenida {
  font-size: 2.4rem;
  font-weight: 700;
  line-height: 1.15;
  margin-bottom: 24px;
}

.login-novedades__titulo {
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 16px;
}

.login-novedad {
  --tipo: #ffffff;
  display: flex;
  gap: 16px;
  padding: 18px 20px;
  margin-bottom: 14px;
  border-radius: 14px;
  font-size: 1rem;
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.34);
  border-left: 5px solid var(--tipo);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
}

.login-novedad--aviso {
  --tipo: #ffb74d;
}

.login-novedad--novedad {
  --tipo: #4fc3f7;
}

.login-novedad--promocion {
  --tipo: #f48fb1;
}

.login-novedad__icono {
  align-self: flex-start;
  padding: 10px;
  border-radius: 12px;
  color: var(--tipo) !important;
  background: rgba(0, 0, 0, 0.22);
}

.login-novedad__tipo {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--tipo);
}

.login-novedad strong {
  font-size: 1.1rem;
  line-height: 1.3;
}

/* Estado del servicio: discreto cuando todo va bien; ámbar o rojo, de un vistazo, cuando no. */
.login-estado {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
  padding: 12px 16px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.login-estado__icono {
  color: inherit !important;
}

.login-estado--normal .login-estado__icono {
  color: #69f0ae !important;
}

.login-estado--demoras {
  color: #3b2f00;
  background: #ffc107;
  border-color: #ffc107;
}

.login-estado--interrumpido {
  color: #fff;
  background: #d32f2f;
  border-color: #ff8a80;
  box-shadow: 0 6px 24px rgba(211, 47, 47, 0.45);
}

.login-novedad p {
  margin-top: 4px;
  font-size: 1rem;
  line-height: 1.45;
  opacity: 0.95;
}

@media (min-width: 960px) {
  .login-contenedor {
    max-width: 1020px;
  }

  .login-caja {
    flex: 0 0 440px;
    margin: 0;
  }

  .login-contenedor--solo {
    max-width: 440px;
  }

  .login-contenedor--solo .login-caja {
    margin: 0 auto;
  }
}

.login-logo {
  display: block;
  width: 64%;
  max-width: 260px;
  margin: 0 auto 20px;
}

</style>

<script>
//import * as firebase from 'firebase';
import appUtil from "@/plugins/app-utils.js";
import TecladoLogin from "@/components/base/TecladoLogin.vue";
import MixinTecladoLogin from "@/components/base/MixinTecladoLogin";
export default {
  name: "Login",
  components: { tecladoLogin: TecladoLogin },
  mixins: [MixinTecladoLogin],
  data: () => ({
    form: { email: "", password: "" },
    social: [
      /*  {
          color: '#55ACEE',
          icon: 'mdi-twitter',
          type: 'twitter',
          text: 'Ingresar con Twitter',
        },*/
      {
        color: "#3B5998",
        icon: "mdi-facebook",
        type: "facebook",
        text: "Ingresar con Facebook",
      },
      {
        color: "#DD4b39",
        icon: "mdi-google",
        type: "google",
        text: "Ingresar con Google",
      },
    ],
    responseError: false,
    // Lo que responde el servidor cuando no deja entrar (empresa inactiva por falta de pago, usuario inactivo…).
    mensajeError: "",
    loading: false,
    // Lo que trae GET api/anuncios (los administra Source en source_config): los anuncios vigentes para esta
    // app y el estado del servicio, que se declara a mano. Sin respuesta, el login queda sin panel.
    novedades: [],
    estadoServicio: null,
    nombreTipo: { aviso: "Aviso", novedad: "Novedad", promocion: "Promoción" },
    iconoEstado: { normal: "mdi-check-circle-outline", demoras: "mdi-alert-outline", interrumpido: "mdi-alert-octagon-outline" },
  }),
  created() {
    const configFormMpn = {
      user: {
        name: "user",
        label: "Usuario",
        validate: ["required"],
        "prepend-inner-icon": "mdi-card-account-details",
        required: true,
        dense: false,
      },
      passwd: {
        name: "passwd",
        label: "Contraseña",
        validate: ["required"],
        "prepend-inner-icon": "mdi-lock-question",
        required: true,
        dense: false,
      },
    };
    //const form = new NgForm(configFormMpn, this)
    //this.form = new Proxy(form, handler)

    //this.form.init();
  },
  computed: {
    valorCampo() {
      return this.campoActivo ? this.form[this.campoActivo] || "" : "";
    },
    hayPanel() {
      return this.novedades.length > 0 || !!this.estadoServicio;
    },
  },
  mounted() {
    this.cargarAnuncios();
    // Llega aquí porque la sesión venció (plugins/http.js): se dice por qué.
    const aviso = localStorage.getItem("aviso_login");
    if (aviso) {
      localStorage.removeItem("aviso_login");
      this.mensajeError = aviso;
      this.responseError = true;
    }
    // Sin sesión guardada no hay nada que preguntarle al servidor: contestaría «Unauthenticated».
    if (!localStorage.getItem("source_tk")) {
      return;
    }
    this.$auth.loadInfoSession().then((response) => {
      if (response.success) {
        this.redirectUrl();
      }
    }).catch(() => {});
  },

  methods: {
    escribirDesdeTeclado(texto) {
      if (this.campoActivo) this.form[this.campoActivo] = texto;
    },
    accionTeclado() {
      if (this.campoActivo === "email") {
        this.campoActivo = "password";
        this.$nextTick(() => {
          const campo = this.$el.querySelectorAll(".login-tarjeta input[type=password], .login-tarjeta input[type=text]");
          if (campo.length) campo[campo.length - 1].focus();
        });
      } else {
        this.tecladoOculto = true;
        this.loginWithPasswd();
      }
    },
    /**
     * Anuncios del login: primero lo último que se vio en este equipo (sin internet o mientras responde el
     * servidor) y luego lo del servidor. Es decoración: si falla, el formulario no se entera.
     */
    cargarAnuncios() {
      const app = window.posEscritorio ? "desktop" : "web";
      try {
        const guardado = JSON.parse(localStorage.getItem("login_anuncios") || "null");
        if (guardado && guardado.app === app) {
          this.aplicarAnuncios(guardado.datos);
        }
      } catch (e) {
        // lo guardado no se pudo leer: se pide de nuevo
      }
      this.$http
        .get("api/anuncios", { app }, false, false, false)
        .then((response) => {
          if (response && response.success && response.item) {
            this.aplicarAnuncios(response.item);
            try {
              localStorage.setItem("login_anuncios", JSON.stringify({ app, datos: response.item }));
            } catch (e) {
              // sin espacio para guardar: no pasa nada
            }
          }
        })
        .catch(() => {});
    },
    aplicarAnuncios(datos) {
      this.novedades = Array.isArray(datos && datos.items) ? datos.items : [];
      this.estadoServicio = (datos && datos.estado) || null;
    },
    redirectUrl() {
      appUtil.redirectUrl(this.$router);
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    },
    async loginWithPasswd() {
      this.responseError = false;
      this.mensajeError = "";
      this.loading = true;
      try {
        let response = await this.$auth.authenticated(this.form);
        if (response.success) {
          this.redirectUrl();
        } else {
          this.mensajeError = response.msg || "";
          this.responseError = true;
        }
      } finally {
        this.loading = false;
      }
    },
    login(type) {
      switch (type) {
        case "google":
          this.signUserInGoogleAuth();
          break;
        case "facebook":
          this.signUserInFacebookAuth();
          break;
        case "twitter":
          this.signUserInTwitterAuth();
          break;
      }
    },

    loginServer(user) {
      if (user) {
        //this.$store.commit('setLoading', true);
        this.$auth.authenticatedUserFirebase(user, this).then((res) => {
          //this.$store.commit('setLoading', false);
          if (res.success) {
            this.$store.commit("setAuth", res.data);
            this.redirectUrl();
          } else {
            this.responseError = true;
          }
        });
      }
    },
    signUserInGoogleAuth() {
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GoogleAuthProvider())
        .then((response) => {
          const newUser = {
            uid: response.user.uid,
            name: response.user.displayName,
            email: response.user.email,
            type: "google",
            photoUrl: response.user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
    signUserInFacebookAuth() {
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.FacebookAuthProvider())
        .then((response) => {
          const newUser = {
            uid: response.user.uid,
            name: response.user.displayName,
            email: response.user.email,
            type: "facebook",
            photoUrl: response.user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
    signUserInGithubAuth() {
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.GithubAuthProvider())
        .then((response) => {
          //commit('setLoading', false)
          const newUser = {
            uid: response.user.uid,
            name: response.user.displayName,
            email: response.user.email,
            type: "github",
            photoUrl: response.user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
    signUserInTwitterAuth() {
      firebase
        .auth()
        .signInWithPopup(new firebase.auth.TwitterAuthProvider())
        .then((response) => {
          const newUser = {
            uid: response.user.uid,
            name: response.user.displayName,
            email: response.user.email,
            type: "twitter",
            photoUrl: response.user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
    signUserInAuth({ commit }, payload) {
      firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then((response) => {
          const newUser = {
            uid: response.user.uid,
            name: response.user.displayName,
            email: response.user.email,
            photoUrl: response.user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
    signUserUpAuth(payload) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password)
        .then((user) => {
          // commit('setLoading', false)
          const newUser = {
            uid: user.uid,
            name: user.displayName,
            email: user.email,
            photoUrl: user.photoURL,
          };
          this.loginServer(newUser);
        })
        .catch((error) => {});
    },
  },
};
</script>
